import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    InputAdornment,
    DialogTitle,
    DialogActions,
    Checkbox,
    Popover, 
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useFormik } from "formik";
import {
  useCreateModifierGrpMutation,
  useGetAllMainCategoryQuery,
  useGetLastProductIdQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetSubCategoryByArrayQuery,
  useGetProductQuery,
  useGetModifierQuery,
  useGetCategoryQuery
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ICategory,
  ILastProductId,
  IPrinter,
  IProduct,
  IModifierPopUp,
  IModifierGrp,
  IProductPopUP,
  IProductBrand,
  IProductTag,
  ModifierInfo,
  ProductInfo,
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { HexColorPicker } from "react-colorful";
import Barcode from "react-barcode";
import AppsIcon from "@mui/icons-material/Apps";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewPrinter from "../../Printer/Edit/index";
import NewProductTag from "../../ProductTags/Edit/index";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { CiSearch } from "react-icons/ci";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditIcon from '@mui/icons-material/Edit';
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import CancelButton from "../../../Components/common/CancelButton";


const steps = ["Basic Details", "Looping Table", "Done"];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};

// Image imports
const img1 = require("../../../Images/img1.jpg");
const img2 = require("../../../Images/img2.jpg");
const img3 = require("../../../Images/img3.jpg");

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const gridHeight = isMobile ? "30px" : "400px";

  const [newModifierGroup, { isLoading }] = useCreateModifierGrpMutation();
   const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =useState<string>("");
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);

  // Row-level edit state
  const [editingRow, setEditingRow] = useState<ProductInfo | null>(null);
  const [editDraft, setEditDraft] = useState<{ price: number; pos: boolean; online: boolean }>({
    price: 0,
    pos: false,
    online: false,
  });
  const [openEditDialog, setOpenEditDialog] = useState(false);

  useEffect(() => {
    setCurrentSearchQueryProduct((debouncedSearchText || "").trim());
  }, [debouncedSearchText]);

  // For selecting rows
const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});

// For dropdown menu
const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);


// For Price Dialog
const [openPriceDialog, setOpenPriceDialog] = useState(false);
const [priceValue, setPriceValue] = useState("");

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();
  // const { data: categoryData } = useGetAllMainCategoryQuery({
  //   departmentId: "",
  //   coursingId: "",
  //   roleId: null,
  //   taxeId: "",
  //   createdDateStart: null,
  //   createdDateEnd: null,
  //   searchText: "",
  //   numberOfLength: 0,
  //   isActive: true,
  //   categoryIsLooping: null,
  //   createdDate: null,
  // });

 


  const { data: modifierData } = useGetModifierQuery({
     productBrandId:  null,
    productCategoryId:  null,
    productTagIds: null,
    modifierViewOnline:null,
    createdDateEnd:  null,
    createdDateStart:null,
    searchText: null,
    createdDate: null,
    id:  "",
    });

  const { data: productBrandData, isLoading: ProductBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });
  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);
 

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const [openProductCategory, setOpenProductCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProductTag, setOpenProductTag] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("#FFFFFF");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);
  const { data: newLastProductIdData, isLoading: lastProductIdIsLoading } =
    useGetLastProductIdQuery();
  const [showBarcode, setShowBarcode] = useState(false);

  const [openLoopingCategoryDialog, setOpenLoopingCategoryDialog] =
    useState(false);
    const [overwriteChoice, setOverwriteChoice] = useState<Record<number, 'yes' | 'no'>>({});
   const [overwritePrices, setOverwritePrices] = useState<Record<number, number>>({});
const [modifiers, setModifiers] = React.useState<ModifierInfo[]>([]);
const [products, setProducts] = React.useState<ProductInfo[]>([]);
const selectedModifierIds = modifiers.map((m) => m.modifier_id);

  const [openGallery, setOpenGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );

       const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

    const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
   productCategoryId: String(productCategoryId), 
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQueryProduct,
    createdDate: null,
    id: null,
  });

 const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];

          const modifierList = useMemo(() => {
        return modifierData?.data as IModifierPopUp[];
      }, [modifierData?.data]);

    const categoryList = useMemo(() => {
      return categoryData?.data as ICategory[];
    }, [categoryData?.data]);

     const filteredModifiers = useMemo(() => {
  return modifierList?.filter(
    (mod) => Number(mod.productCategoryId) === Number(selectedCategoryId)
  );
}, [modifierList, selectedCategoryId]);

  const formik = useFormik<IModifierGrp>({
    initialValues: {
      modifierGroupName: "",
      minimum:0,
      maximum:0,
      categoryId: "",
      modifiers: [], 
      isActive: true,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
     
    const modifierDetails = products.map((mod) => ({
  product_id: mod.product_id,
  price: Number(mod.price) || 0,
  pos: !!mod.pos,
  online: !!mod.online,
}));


        const formData = new FormData();

        const temData = {
          modifierGroupName: values.modifierGroupName,
          minimum: values.minimum,
          maximum: values.maximum,
          categoryId: selectedCategoryId,
          modifiers: modifierDetails, 
          isActive: values.isActive,
        };

        const addProductResponse = await newModifierGroup(temData).unwrap();
        if (!addProductResponse.status) {
          showErrorMessage(addProductResponse.message);
        } else {
          showMessage(addProductResponse.message);
          navigate("/modifierGrp/list");
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    if (!formik.values.modifierGroupName?.trim()) return false;
    if (!products || products.length === 0) return false;
    return true;
  }, [formik.values.modifierGroupName, products]);

  
  const openGalleryDialog = () => {
    setOpenGallery(true);
  };

  const closeGalleryDialog = () => {
    setOpenGallery(false);
  };

const applyBulkToggle = (field: "pos" | "online") => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, [field]: !item[field] }
      : item
  );
  setProducts(updated);
};




const applyPriceUpdate = () => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, price: Number(priceValue) }
      : item
  );
  setProducts(updated);
  setOpenPriceDialog(false);
};



  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target as Node)
      ) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
const handleModifierChange = (e: React.ChangeEvent<{ value: unknown }>) => {
  const value = e.target.value;
  const selectedIds =
    typeof value === "string"
      ? value.split(',').map(Number)
      : (value as number[]);

  const newModifiers = selectedIds.map((id) => {
    const existing = modifiers.find((m) => m.modifier_id === id);
    return existing ?? {
      modifier_id: id,
      overwrite: false,
      overwrite_price: null,
    };
  });

  setModifiers(newModifiers);
};

const handleAddModifier = (product: IProductPopUP) => {
  const alreadyAdded = products.some((m) => m.product_id === product.id);
  if (!alreadyAdded) {
    setProducts([
      ...products,
      {
        product_id: product.id,
        price: null,
        pos: false,
        online: false
      },
    ]);
  }
};


const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );

    if (selectedCategory) {
      formik.setFieldValue(
        "productDetailsIsLooping",
        selectedCategory.categoryIsLooping
      );
      formik.setFieldValue(
        "productsDetailsLoopingConstant",
        selectedCategory.categoryLoopingConstant
      );
    }
  };

  
  if (
    isLoading ||
    ProductBrandLoading ||
    ProductTagLoading ||
    PrinterLoading ||
    lastProductIdIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const cancelFunction = () => {
    formik.resetForm();
    setSelectedImage(undefined);
    setOpenGallery(false);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

 


  return (
    <div>



    <Grid container spacing={3}>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Card className={classes.stepperCard}  sx={{ mb: 2 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >

<Grid container spacing={3} p={"5px"}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
                <TextField
                 label="Modifier Group Name"
                              // placeholder="Enter Modifier Group Name"
                              size="small"
                              {...formik.getFieldProps("modifierGroupName")}
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                            </Grid>
                            </Grid>

                                 {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
                <TextField
                 label="Minimum"
                              // placeholder="Enter Minimum"
                              size="small"
                              {...formik.getFieldProps("minimum")}
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                            </Grid>
                            </Grid>

                                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
                <TextField
                              label="Maximum"
                              // placeholder="Enter Maximum"
                              type="number"
                              size="small"
                              {...formik.getFieldProps("maximum")}
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                            </Grid>
                            </Grid> */}

                             <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">

                                <TextField
                                 label="Category"
                                                   select
                                                   fullWidth
                                                   size="small"
                                                   className={classes.textField}
                                                   value={selectedCategoryId ?? ""}
                                                   onChange={handleMainCategoryChange}
                                                   InputLabelProps={{ shrink: true }}
                                                 >
                                                   <MenuItem
                                                     value=""
                                                    
                                                     style={{ color: "gray" }}
                                                   >
                                                     Select Category
                                                   </MenuItem>
                                                   {categoryList &&
                                                     categoryList
                                                     .filter((category) => !category.parent_ids || category.parent_ids.length === 0) 
                                                     .map((category) => (
                                                       <MenuItem
                                                         key={category.id}
                                                         value={category.id}
                                                       >
                                                         {category.categoryName}
                                                       </MenuItem>
                                                     ))}
                                                 </TextField>
                                                 </Grid></Grid>



  <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search product.."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>
  </Grid>
  

                                                 </Grid>


              </Grid>
            </Grid>
          </Card>


           <Card className={classes.stepperCard} sx={{height: 280, overflowY: 'auto'}}>
          <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                       Product List
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"5px"}>
                                         

        {selectedCategoryId && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
<Box sx={{ padding: 2 }}> 
  {(() => { 

        // Step 1: Collect all child category IDs including itself
        const relatedCategoryIds = [
          Number(selectedCategoryId),
          ...categoryList
            .filter(
              (cat) =>
                cat.parent_ids &&
                Array.isArray(cat.parent_ids) &&
                cat.parent_ids.includes(Number(selectedCategoryId))
            )
            .map((cat) => Number(cat.id)),
        ];

        // Step 2: Filter products belonging to any of these categories
  const filtered = productList.filter(
  (mod) =>
    relatedCategoryIds.includes(Number(mod.productCategoryId)) &&
    mod.productName.toLowerCase().includes(searchText.toLowerCase()) &&
    !products.some((p) => Number(p.product_id) === Number(mod.id))
);



        return filtered.length > 0 ? (
          filtered.map((mod) => (
            <Box
              key={mod.id}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography>{mod.productName}</Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleAddModifier(mod)}
              >
                Add
              </Button>
            </Box>
          ))
        ) : (
          <Typography
            sx={{ textAlign: "center", padding: 2}}
          >
            No products found
          </Typography>
        );
      })()}
    </Box>
  </Grid>
)}

                  
 
                    </Grid>
                  </Card>
                </Grid>

              
        
        <Grid item lg={8} md={8} sm={12} xs={12}>
         
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height:500, overflowY: 'auto' }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>
                       Modifier
                      </Typography>
                    </Grid>

  <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
           
            <Grid item>
              <Button
                variant="contained"
                className={classes.addButton}
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                disabled={
                  products.length === 0 ||
                  !Object.values(selectedRows).some((v) => v)
                }
                title={
                  products.length === 0
                    ? "Add modifiers first"
                    : !Object.values(selectedRows).some((v) => v)
                    ? "Select at least one row"
                    : "Bulk update selected rows"
                }
              >
                Bulk Update
              </Button>
            </Grid>
          </Grid>
        </Grid>

                  </Grid>



   {selectedCategoryId && (
          
  <Grid>
     
     <TableContainer>
    <Table className={classes.table}>
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
          <TableCell className={classes.tablheader}><strong>Product Name</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Price</strong></TableCell>
            <TableCell className={classes.tablheader}><strong>Online</strong></TableCell>
              <TableCell className={classes.tablheader}><strong>POS</strong></TableCell>
          {/* <TableCell className={classes.tablheader}><strong>Overwrite?</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Overwrite Price</strong></TableCell> */}
          <TableCell className={classes.tablheader}><strong>Action</strong></TableCell>
            <TableCell className={classes.tablheader}>
                <Checkbox
  checked={
    products.length > 0 &&
    products.every((item) => selectedRows[Number(item.product_id)])
  }
  indeterminate={
    products.some((item) => selectedRows[Number(item.product_id)]) &&
    !products.every((item) => selectedRows[Number(item.product_id)])
  }
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    const newSelected: Record<number, boolean> = {};
    if (e.target.checked) {
      products.forEach((item: ProductInfo) => {
        newSelected[Number(item.product_id)] = true;
      });
    }
    setSelectedRows(newSelected);
  }}
/>



                          </TableCell>
        </TableRow>
      </TableHead>
    <TableBody>
  {products.map((mod, index) => {
    const modInfo = productList.find((m) => m.id === mod.product_id);
    return (
      <TableRow key={mod.product_id}>
        <TableCell>{modInfo?.productName}</TableCell>
    <TableCell>
  <TextField
    type="number"
    size="small"
    value={mod.price || ""}
     onChange={(e) => {
        const value = e.target.value;
  const updated = [...products];
  updated[index] = {
    ...updated[index],
    price: value === "" ? 0 : Number(value), 
  };

  setProducts(updated);
}}
  
    sx={{ width: 100 }}
  />
</TableCell>

       <TableCell>
  <IOSSwitch
    checked={mod.online ?? false}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
      const updated = [...products];
      updated[index] = {
        ...updated[index],
        online: event.target.checked, //  use checked
      };
      setProducts(updated);
    }}
  />
</TableCell>

{/* POS SWITCH */}
<TableCell>
  <IOSSwitch
    checked={mod.pos ?? false}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
      const updated = [...products];
      updated[index] = {
        ...updated[index],
        pos: event.target.checked, 
      }
      setProducts(updated);
    }}
  />
</TableCell>

      
        <TableCell>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              size="small"
              onClick={() => {
                const row = products.find((p) => p.product_id === mod.product_id) || null;
                if (!row) return;
                setEditingRow(row);
                setEditDraft({
                  price: Number(row.price) || 0,
                  pos: !!row.pos,
                  online: !!row.online,
                });
                setOpenEditDialog(true);
              }}
              sx={{
                backgroundColor: '#e0f7fa',
                borderRadius: '50%',
                padding: '4px',
                '&:hover': { backgroundColor: '#b2ebf2' },
              }}
            >
              <EditIcon fontSize="small" sx={{ color: '#00838f' }} />
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => {
                const updated = products.filter(
                  (item) => item.product_id !== mod.product_id
                );
                setProducts(updated);
              }}
              sx={{
                backgroundColor: '#f8d7da',
                borderRadius: '50%',
                padding: '4px',
                '&:hover': { backgroundColor: '#f1b0b7' },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </TableCell>

          <TableCell className={classes.tablCell}>
                    <Checkbox
  checked={selectedRows[Number(mod.product_id)] || false}
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRows({
      ...selectedRows,
      [Number(mod.product_id)]: e.target.checked,
    });
  }}
/>




                              </TableCell>
      </TableRow>
    );
  })}
</TableBody>

    </Table>
    </TableContainer>
  
  </Grid>
     )}


                </Card>
              </Grid>

           
            </Grid>
       
        </Grid>





  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <CancelButton to="/modifierGrp/list" className={classes.addButton} />
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
          </Card>
          
        </Grid>

      </Grid>

<Popover
  open={Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={() => setAnchorEl(null)}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
>
  <MenuItem
    onClick={() => {
      setAnchorEl(null);
      setOpenPriceDialog(true);
    }}
  >
    Price
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("pos");
      setAnchorEl(null);
    }}
  >
    POS
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("online");
      setAnchorEl(null);
    }}
  >
    Online
  </MenuItem>
</Popover>

<Dialog
  open={openEditDialog}
  onClose={() => { setOpenEditDialog(false); setEditingRow(null); }}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle>Edit Modifier</DialogTitle>
  <DialogContent>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <TextField
        label="Price"
        type="number"
        size="small"
        fullWidth
        value={editDraft.price}
        onChange={(e) =>
          setEditDraft((d) => ({ ...d, price: Number(e.target.value) || 0 }))
        }
        inputProps={{ min: 0, step: '0.01' }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ minWidth: 60 }}>POS</Typography>
        <IOSSwitch
          checked={editDraft.pos}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEditDraft((d) => ({ ...d, pos: e.target.checked }))
          }
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ minWidth: 60 }}>Online</Typography>
        <IOSSwitch
          checked={editDraft.online}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEditDraft((d) => ({ ...d, online: e.target.checked }))
          }
        />
      </Box>
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => { setOpenEditDialog(false); setEditingRow(null); }}>
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={() => {
        if (!editingRow) return;
        setProducts((prev) =>
          prev.map((p) =>
            p.product_id === editingRow.product_id
              ? {
                  ...p,
                  price: Number(editDraft.price) || 0,
                  pos: editDraft.pos,
                  online: editDraft.online,
                }
              : p
          )
        );
        setOpenEditDialog(false);
        setEditingRow(null);
      }}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>


<Dialog open={openPriceDialog} onClose={() => setOpenPriceDialog(false)}>
  <DialogTitle>Update Price</DialogTitle>

  <DialogContent>
    <TextField
      label="Enter Price"
      type="number"
      fullWidth
      size="small"
      value={priceValue}
      onChange={(e) => setPriceValue(e.target.value)}
       inputProps={{ min: 0 }} 
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenPriceDialog(false)}>Cancel</Button>

    <Button variant="contained" onClick={applyPriceUpdate}>
      Apply
    </Button>
  </DialogActions>
</Dialog>



   
    </div>
  );
};

export default Index;
